

















































import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { email, required } from 'vuelidate/lib/validators';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import BravadoInput from '../../ui/BravadoInput.vue';
import EnvelopeAltIcon from '../images/icons/envelope-alt-icon.vue.svg';
import { FormState } from '~/types/common';

export default Vue.extend({
  name: 'MainPageSubscribe',
  components: {
    BravadoButtonV3,
    BravadoInput,
    EnvelopeAltIcon,
  },
  mixins: [validationMixin],
  data(): { email: string; formState: FormState } {
    return {
      email: '',
      formState: 'idle',
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    async onSubscribeClick(): Promise<void> {
      this.$analytics.logEvent('email__subscribe__cta-button__click');
      this.formState = 'submitting';
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$v.$reset();
        await this.$api.$post('/subscriptions.json', { email: this.email });
        this.formState = 'success';
        this.email = '';
      } else {
        this.formState = 'idle';
      }
    },
  },
});
